import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-approval-status-card',
  templateUrl: './approval-status-card.component.html',
  styleUrls: ['./approval-status-card.component.scss']
})
export class ApprovalStatusCardComponent implements OnInit {
  @Input() buySellPlanEmployee: any;

  constructor() { }

  ngOnInit(): void {
  }

  getStatusChipClass(): string {
    const statusId = this.buySellPlanEmployee?.status?.id;
    const classMap = {
      'DENIED': 'red-chip',
      'APPROVED': 'green-chip',
      'Complete': 'green-chip',
      'PENDING': 'orange-chip',
      'PENDING_APPROVAL': 'blue-chip',
      'AVAILABLE': 'blue-chip'
    };
    return classMap[statusId] || '';
  }

}
